import { render } from "./CadastroVeiculoAntt.vue?vue&type=template&id=2b340730&scoped=true"
import script from "./CadastroVeiculoAntt.vue?vue&type=script&lang=ts"
export * from "./CadastroVeiculoAntt.vue?vue&type=script&lang=ts"

import "./CadastroVeiculoAntt.vue?vue&type=style&index=0&id=2b340730&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2b340730"

export default script